import React from "react";
import HealthTable from "./HealthTable";

class HealthAndSafety extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      isOpenCreateRequest: props.location.aboutProps ? props.location.aboutProps.isOpenCreateRequest : false
    }
  }

  render() {
    const {isOpenCreateRequest} = this.state;
    return (
      <div className={"requests-body-wrapper"}>
        <div className={"row request-table"}>
          {
            <HealthTable
              isOpenCreateRequest={isOpenCreateRequest || false}
              history={this.props.history}
            />
          }
        </div>
      </div>
    );
  }
}
export default HealthAndSafety;
